// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"513":"88aa3c47","703":"e891e290","787":"a7c99489"}[chunkId] + ".chunk.js";
};